import { Accordion, AccordionDetails, Box, Fab, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Tooltip, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react'
import StyledTableCell from '../Components/Common/styledTableCell';
import DataNotFound from '../Components/Common/DataNotFound';
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CustomPagination from '../Components/Common/CommonPagination';
import { get_transaction_list, getAvailableAccess, getParticularUserTransaction, getTransactionHistory } from '../Redux/Actions/action';
import { showLoader } from '../Redux/Slices/loaderSlice';
import { useDispatch } from 'react-redux';
import ErrorHandler, { PaymentStatus } from '../Utils/handler';
import { toast } from 'react-toastify';
import CommonSearchField from '../Components/Common/CommonSearchField';
import { useNavigate } from 'react-router';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import dayjs from 'dayjs';
import PersonIcon from '@mui/icons-material/Person';
import TextLabel from '../Components/Common/CommonTextLabel';
import ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';

const StyledTableCellAccodion = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        // backgroundColor: theme?.palette?.primary?.main,
        color: theme?.palette?.primary?.main,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
    padding: '8px',
    fontWeight: "600",
    textAlign: "center"
}));

const StyledTableRowAccodion = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
    backgroundColor: "#e6e6e6",
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    // color: "white",
    minHeight: 40,
    '&.Mui-expanded': {
        minHeight: 40,
    },
    '& .MuiAccordionSummary-content': {
        margin: '0px',
        '&.Mui-expanded': {
            margin: '0px',

        },
    },
}));

const capitalizeFirstLetter = (val) => {
    return val?.charAt(0)?.toUpperCase() + val?.slice(1)
}

const TransactionHistory = () => {
    // ---------- Hook -----------
    const dispatch = useDispatch();
    const theme = useTheme();

    // --------------- State -------------
    const [transactionHistoryList, setTransactionHistoryList] = useState();
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [searchText, setSearchText] = useState("");
    const [data, setData] = useState({ response: [], count: 0 });
    const [openAccordion, setOpenAccordion] = useState(null);
    const [activeAccordion, setActiveAccordion] = useState(null);

    // --------------- handleChange ---------------
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(1);
    };

    const handleAccordionClick = (userId, index) => {
        if (openAccordion === index) {
            setActiveAccordion(null);
            setOpenAccordion(null);
            setData({ response: [], count: 0 });
        } else {
            setActiveAccordion(index);
            setOpenAccordion(index);
            _getUserTransactionHistory(userId);
        }
    };

    // --------------- Api  --------------- 
    const _getTransactionHistory = async () => {
        dispatch(showLoader(true))
        let body = {
            page: page,
            limit: rowsPerPage,
        }
        if (searchText) {
            body.search = searchText || ""
        }
        try {
            const result = await dispatch(getTransactionHistory(body));
            const error = ErrorHandler(result);
            if (error) {
                setTransactionHistoryList(result?.payload?.data);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    }

    const _getUserTransactionHistory = async (id) => {
        dispatch(showLoader(true))
        let body = { userId: id }
        try {
            const result = await dispatch(getParticularUserTransaction(body));
            const error = ErrorHandler(result);
            if (error) {
                setData(result?.payload?.data);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    }

    // const _generateExcel = (data) => {
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet('Sheet 1');

    //     const headerRowValues =
    //         [
    //             "No",
    //             "PpskId",
    //             "Receipt No",
    //             "Full Name",
    //             "Transaction Date",
    //             "Transaction ID",
    //             "Phone Number",
    //             "Dob",
    //             "Amount",
    //             "Status",
    //             "VerificationStatus",
    //         ];
    //     const headerRow = worksheet.addRow(headerRowValues);

    //     headerRow.eachCell((cell) => {
    //         cell.fill = {
    //             type: 'pattern',
    //             pattern: 'solid',
    //             fgColor: { argb: '3e4094' } // Background color
    //         };
    //         cell.font = { bold: true, color: { argb: 'FFFFFF' } }; // White text, bold font
    //     });
    //     // Add data rows
    //     data?.forEach((val, index) => {
    //         worksheet.addRow([
    //             index + 1,
    //             val?.ppskId || "-",
    //             val?.receiptNo || "-",
    //             val?.fullName || "-",
    //             dayjs(val?.transactionDate).format("ll") || "-",
    //             val?.transactionId || "-",
    //             val?.phoneNumber || "-",
    //             dayjs(val?.dob).format("ll") || "-",
    //             val?.amount || "-",
    //             val?.status || "-",
    //             val?.verificationStatus || "-",
    //         ]);
    //     });

    //     worksheet.columns = [
    //         { width: 10 }, { width: 18 }, { width: 25 },
    //         { width: 40 }, { width: 20 }, { width: 30 },
    //         { width: 20 }, { width: 20 }, { width: 10 },
    //         { width: 15 }, { width: 20 }];
    //     // Save workbook to file
    //     workbook.xlsx.writeBuffer().then(buffer => {
    //         const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //         FileSaver.saveAs(data, `${`Document ${dayjs(new Date()).format('DD/MM/YYYY')}`}`);
    //     }).catch(err => {
    //         console.error("Error generating Excel:", err);
    //     });
    // };

    // const _downloadAllTransactionHistory = async () => {
    //     dispatch(showLoader(true))
    //     try {
    //         const result = await dispatch(get_transaction_list({}));
    //         const error = ErrorHandler(result);
    //         if (error) {
    //             // console.log(result?.payload?.data, "sasdataa")
    //             _generateExcel(result?.payload?.data?.response)
    //         }
    //     } catch (error) {
    //         toast.error(error);
    //     } finally {
    //         dispatch(showLoader(false));
    //     }
    // }

    // ----------- useEffect -----------
    
    useEffect(() => {
        dispatch(showLoader(true));
        dispatch(getAvailableAccess())
            .unwrap()
            .catch((error) => console.error("error", error))
            .finally(() => dispatch(showLoader(false)));
    }, [dispatch]);

    useEffect(() => {
        _getTransactionHistory();
    }, [page, rowsPerPage, searchText]);

    return (
        <>
            <Grid container spacing={2} xs={12} sm={12} md={12} lg={12} >
                <Grid item xs={12}  >
                    <Paper elevation={0} sx={{ padding: 2, background: "#fff" }}>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={{ sm: "center", xs: "start" }} mb={2} gap={2} flexDirection={{ sm: "row", xs: "column" }}>
                            <Typography sx={{ fontSize: { lg: 24, md: 20, xs: 18 } }} fontWeight={"medium"} color={"#3E4094"}>Transaction History</Typography>
                            <CommonSearchField placeholder={"Search.."} tooltipList={["Name", "Ppsk Id", "Transaction Id"]} handleSearch={(e) => { setPage(1); setSearchText(e); }} />
                        </Box>

                        {/* <Box display={"flex"} justifyContent={"flex-end"} alignItems={"center"} my={1.5} >
                            <Tooltip title="Download Transaction History">
                                <Fab disabled={transactionHistoryList?.response?.length === 0} sx={{ width: '30px', height: '30px', boxShadow: 'none', minHeight: "30px", padding: 0 }} onClick={() => _downloadAllTransactionHistory()} color="primary">
                                    <SimCardDownloadOutlinedIcon sx={{ fontSize: '20px' }} />
                                </Fab>
                            </Tooltip>
                        </Box> */}

                        <TableContainer  >
                            {transactionHistoryList?.response?.length > 0 ? transactionHistoryList?.response?.map((item, index) => (
                                <Accordion
                                    expanded={activeAccordion === index}
                                    sx={{ mb: "5px", boxShadow: "none", minWidth: "700px" }}
                                    key={index}
                                    elevation={'0px'}
                                >
                                    <AccordionSummary
                                        onClick={() => { handleAccordionClick(item?.userId, index) }}
                                        sx={{ backgroundColor: "#f8f8fa", borderRadius: "5px", padding: "5px 20px" }}
                                        expandIcon={<ExpandMoreIcon sx={{ color: "primary" }} />}>

                                        <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
                                                {/* {index + 1} */}
                                                {(index % rowsPerPage) + 1 + (page - 1) * rowsPerPage}
                                                <PersonIcon color='primary' />
                                                <Typography style={{ color: theme?.palette?.primary?.main, fontSize: "14px", textDecoration: 'uppercase' }}>{capitalizeFirstLetter(item?.fullName) || "NA"}</Typography>
                                            </Box>

                                            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                                                <Box textAlign={"center"}>
                                                    <Typography style={{ color: theme?.palette?.primary?.main, fontSize: "12px", fontWeight: "600" }}>{`Transaction ID`}</Typography>
                                                    <Typography style={{ fontSize: "13px" }}>{item?.transactionId || "-"}</Typography>
                                                </Box>

                                                <Box textAlign={"center"} >
                                                    <Typography style={{ color: theme?.palette?.primary?.main, fontSize: "12px", fontWeight: "600" }}>{`PPSK ID`}</Typography>
                                                    <Typography style={{ fontSize: "13px" }}>{item?.ppskId}</Typography>
                                                </Box>
                                            </Box>
                                        </Box>

                                    </AccordionSummary>
                                    <AccordionDetails sx={{ padding: "5px 2px 5px" }}>
                                        <Table size="small" aria-label="transaction details">
                                            <TableHead>
                                                <StyledTableRowAccodion>
                                                    <StyledTableCellAccodion>No</StyledTableCellAccodion>
                                                    <StyledTableCellAccodion>Date</StyledTableCellAccodion>
                                                    <StyledTableCellAccodion>Transaction ID</StyledTableCellAccodion>
                                                    <StyledTableCellAccodion>Receipt No</StyledTableCellAccodion>
                                                    <StyledTableCellAccodion>Amount</StyledTableCellAccodion>
                                                    <StyledTableCellAccodion>Status</StyledTableCellAccodion>
                                                </StyledTableRowAccodion>
                                            </TableHead>
                                            <TableBody>
                                                {data?.count > 0 && data?.response?.map((transaction, tIndex) => (
                                                    <TableRow key={tIndex}>
                                                        <StyledTableCell>{tIndex + 1}</StyledTableCell>
                                                        <StyledTableCell>{dayjs(transaction?.createdAt).format("DD/MM/YYYY") || "-"}</StyledTableCell>
                                                        <StyledTableCell>{transaction?.transactionId || "-"}</StyledTableCell>
                                                        <StyledTableCell>{transaction?.receiptNo || "-"}</StyledTableCell>
                                                        <StyledTableCell>{transaction?.amount || "-"}</StyledTableCell>
                                                        <StyledTableCell>
                                                            <PaymentStatus label={transaction?.status} status={transaction?.status} />
                                                        </StyledTableCell>
                                                    </TableRow>
                                                ))}
                                                {!data?.response &&
                                                    (<TableRow>
                                                        <StyledTableCell colSpan={11}>
                                                            <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                                                        </StyledTableCell>
                                                    </TableRow>)}
                                            </TableBody>
                                        </Table>
                                    </AccordionDetails>
                                </Accordion>
                            )) :
                                (
                                    <Table size="small" aria-label="transaction details">
                                        <TableRow>
                                            <StyledTableCell colSpan={11}>
                                                <DataNotFound title={'No Records Found'} icon={<ErrorOutlineIcon color="primary" style={{ fontSize: "3rem" }} />} elevation={0} />
                                            </StyledTableCell>
                                        </TableRow>
                                    </Table>
                                )
                            }
                        </TableContainer>

                        {transactionHistoryList?.count > 0 &&
                            <Grid item xs={12}>
                                <CustomPagination
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    count={Math.ceil(transactionHistoryList?.count / rowsPerPage)}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleChangeRowsPerPage} />
                            </Grid>}
                    </Paper>
                </Grid>

            </Grid >
        </>
    )
}

export default TransactionHistory
